import React from 'react'

import feature1 from '../../assets/Images/feature1.png';
import feature2 from '../../assets/Images/feature2.png';
import feature3 from '../../assets/Images/feature3.png';
import feature4 from '../../assets/Images/feature4.png';

function Cards() {
    return (
        <section className='cards position-relative'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1500">
                        <div className='card-content'>
                            <figure>
                                <img src={feature1} alt="feature1.img" />
                            </figure>
                            <h3>Customized Strategies</h3>
                            <p>Our team crafts personalized strategies that resonate with your brand and objectives, ensuring maximum impact and engagement. We understand that every business is different and create custom solutions to drive your success.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6" data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1500">
                        <div className='card-content'>
                            <figure>
                                <img src={feature2} alt="feature1.img" />
                            </figure>
                            <h3>Innovative Design Solutions</h3>
                            <p>From UI/UX design to graphic content, we bring your vision to life with designs that captivate your audience. Our focus on innovation ensures that your brand stands out in a competitive market.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mt" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1500">
                        <div className='card-content'>
                            <figure>
                                <img src={feature3} alt="feature1.img" />
                            </figure>
                            <h3>Data-Driven Marketing</h3>
                            <p>Our approach is rooted in data, using insights and analytics to fine-tune campaigns and drive measurable results. We make sure every marketing decision is backed by solid data for the best outcomes.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mt" data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1500">
                        <div className='card-content'>
                            <figure>
                                <img src={feature4} alt="feature1.img" />
                            </figure>
                            <h3>Scalable Solutions</h3>
                            <p>We provide scalable solutions that adapt as your business grows. From websites to digital campaigns, our services are built to support your evolving needs and long-term objectives.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Cards
